import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/features/auth/auth-context'

export function RequireAuth() {
  const { profile, loading } = useAuth()
  const location = useLocation()

  if (loading) return <div className="app-loading" role="status">Opening your study journal…</div>
  if (!profile) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  return <Outlet />
}
